import { Box, TextField, Typography } from "@mui/material";
import DesignationSelect from "../../utils/designationSelect";

// Converts dd-MM-yyyy (stored) → yyyy-MM-dd (for HTML date input display)
const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
};

// Converts yyyy-MM-dd (from HTML date input) → dd-MM-yyyy (for storage / backend)
const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};


const NurturAppointmentLetterForm = ({ data, setData }) => {

    const handleChange = (key, value) => {
        if (key === "appointment_date" || key === "joining_date") {
            value = formatDateForStorage(value);
        }

        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Box sx={{ mt: 1 }}>



            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 2
                }}
            >
                <Box>
                    <TextField
                        type="date"
                        label="Appointment Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.appointment_date ? formatDateForInput(data.appointment_date) : ""}
                        onChange={(e) => handleChange("appointment_date", e.target.value)}
                    />
                </Box>

                {/* <Box>
                    <TextField
                        label="Employee Address"
                        fullWidth
                        value={data.employee_address || ""}
                        onChange={(e) => handleChange("employee_address", e.target.value)}
                    />
                </Box> */}

                <Box>
                    <DesignationSelect
                        value={data.designation || ""}
                        onChange={(e) => handleChange("designation", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Joining Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.joining_date ? formatDateForInput(data.joining_date) : ""}
                        onChange={(e) => handleChange("joining_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="number"
                        label="Salary"
                        fullWidth
                        value={data.salary || ""}
                        onChange={(e) => handleChange("salary", e.target.value)}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default NurturAppointmentLetterForm;
